// extracted by mini-css-extract-plugin
export var categoryFooter = "Footer-module--category-footer--cc430";
export var container = "Footer-module--container--d1cf6";
export var copyright = "Footer-module--copyright--bfb99";